import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-draw-point",
  "use": "icon-draw-point-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-draw-point\"><path d=\"M512 512m-186.88 0a186.88 186.88 0 1 0 373.76 0 186.88 186.88 0 1 0-373.76 0Z\" p-id=\"53027\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol